import React from 'react';

interface ShortcutSectionProps {
  children: React.ReactNode;
  headerNote?: React.ReactNode;
  title: string;
}

const ShortcutSection = ({
  children,
  headerNote,
  title,
}: ShortcutSectionProps) => {
  return (
    <div className="shortcut-section">
      <div className="shortcut-section-header">
        <h3>{title}</h3>
        <div className="shortcut-section-note">{headerNote}</div>
      </div>
      <table className="table">
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default ShortcutSection;
